/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path hooks
 * @description Link creation hook
 */
import { useCurrentTenant } from "@qpr/client-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAppContext } from "./../context/AppCtxProvider";
const useLink = (options?: { noPeriod?: boolean }) => {
  const history = useHistory();
  const ctx = useAppContext();
  const tenant = useCurrentTenant();
  const cb = React.useCallback(
    (params: {
      page?: string;
      meaId?: string;
      period?: string;
      model?: string;
      wf?: string;
      type?: string;
    }) => {
      const pathParts = [
        tenant.symbol,
        params.model || ctx.modelId || "undefined",
        params.page || ctx.page,
        params.meaId || ctx.elementId || "",
      ];
      const queryParts: string[] = [];
      if (!options?.noPeriod) {
        queryParts.push(`period=${params.period || ctx.originalPeriod}`);
      }
      if (params.wf) queryParts.push(`wf=${params.wf}`);
      if (params.type) queryParts.push(`type=${params.type}`);
      const getQueryPart = () => {
        if (queryParts.length > 0) {
          return `?${queryParts.join("&")}`;
        }
        return "";
      };
      const URL = `/${pathParts.join("/")}${getQueryPart()}`;
      history.push(URL);
    },
    [ctx.rootUrl, ctx.elementId, ctx.page, ctx.originalPeriod]
  );
  return cb;
};
export default useLink;
